import { get } from "../../utils/objectHelpers";

$ {
    const autoCompleteName = get(input, "storeSearchField.autocomplete.action.name", "");
}

<div class="str-search-wrap">
    <form class="str-search" role="form" on-submit("onSubmit")>
        <ebay-search-icon class=state.iconClass/>
        <input name="_bkw" class=`str-search__input ${state.inputClass}` value=state.keyword
                    placeholder=state.placeHolderText autocomplete="off"
                    on-input("handleInput") on-focus("handleFocus")
                    on-blur("handleBlur") on-keydown("handleInputNav") />
        <ul
            role="listbox"
            aria-label=autoCompleteName
            class=`str-search__suggestions ${state.suggestionListClassOpen}`
            on-mouseup("handleSuggestListSelect")
        >
            <for|suggestion| of=state.suggestions>
                <li value=suggestion.text tabindex="-1" aria-label=suggestion.text
                    class=(suggestion.active && ".active")
                    aria-selected=(suggestion.active && "true")
                    role="option" on-keydown("handleResultsNav") on-focus("toggleActive") >
                    ${suggestion.text}
                </li>
            </for>
        </ul>
    </form>
</div>
